import * as React from "react";
import cx from "classnames";

import { Category } from "../../../models";

export interface CategoryItemProps extends Category {
  onClick: () => void;
  active?: boolean;
}

const getImgClasses = ({ active }: CategoryItemProps) =>
  cx("category-list__item-img", "img-responsive", {
    "category-list__item-img--active": active,
  });

const altName = (category: Category) => `${category.code}-${category.name}`;

const CategoryItem = (props: CategoryItemProps) => (
  <div className="col-md-4 col-sm-6">
    <div className="category-list__item" title={altName(props)}>
      <img
        className={getImgClasses(props)}
        src={props.image}
        alt={altName(props)}
        onClick={props.onClick}
      />
      <h3 className="category-list__item-header">{props.name}</h3>
    </div>
  </div>
);

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/CategoryItem.tsx